<ng-container *ngIf="alleItems">
  <table class="table">
    <tr>
      <th>Reise</th>
      <th *ngIf="alleItems.mehrereTeilnehmer">Teilnehmer</th>
      <th>Kategorie</th>
      <th *ngIf="alleItems.kurseGebucht">Guiding</th>
      <th>Kurtaxe</th>
      <th>Sorgenfrei-Tarif</th>
    </tr>
    <tr *ngFor="let item of alleItems.buchungen">
      <td>{{item.reise.dateString}} {{item.reise.name}}</td>
      <td *ngIf="alleItems.mehrereTeilnehmer">{{item.teilnehmer.name()}}</td>
      <td style="text-align:right">{{item.kategorie | namePreis}}</td>
      <td *ngIf="alleItems.kurseGebucht">{{item.kurs | name}}</td>
      <td>{{item.kurtaxe | preis}}</td>
      <td>{{item.sorgenfreiTarif | preis}}</td>
    </tr>
    <tr>
      <th [colSpan]="1 + alleItems.mehrereTeilnehmer + alleItems.kurseGebucht">Gesamt</th>
      <th style="text-align:right">{{alleItems.gesamtBetrag | preis}}</th>
      <th></th>
      <th></th>
    </tr>
  </table>
  <div [hidden]="!alleItems.kurseGebucht" class="alert alert-info">
    {{service.texte.hinweiseGuiding()}}
  </div>
  <div [hidden]="!alleItems.jgdOderKind" class="alert alert-info"
       [innerHTML]="service.texte.hinweisEinverstaendniserklaerungJugend()">
  </div>
</ng-container>
